import React, { useState, useEffect, useReducer, useRef } from 'react';
import { SFuncModal } from 'shj-components'
import { Divider, message, Spin } from 'antd';
import { SActionBtn, SLowcodeList, STableActions } from 'shj-components'
import { findVerifyApplyResponseList, cancelVerify } from '@/services/fmsServices'
import { getAuth } from '@/utils/auth'
export function verifyApplyFn({ fn, ...rest }) {
  const onClose = () => {
    dialog.destroy();
  };

  const dialog = SFuncModal({
    title: `${rest.sourceBillType==='verifySourceTypeReceipt'?'收款':'应收'}核销明细查询`,
    width: 1000,
    vanish: true,
    content: <ModalAddOrEditVerifyApply onClose={onClose} fn={fn} {...rest} />,
  });

  return dialog;
}
const ModalAddOrEditVerifyApply = ({ onClose, fn, ...rest }) => {
  let listRef = useRef<any>();
  let auth = getAuth()
  const [addOrEditFooterLoading, setAddOrEditFooterLoading] = useState(false);

  const cancel = (record) => {
    setAddOrEditFooterLoading(true)
    cancelVerify({
      id: record.id
    }).then((res)=>{
      message.success(res.message || '取消成功')
      setAddOrEditFooterLoading(false)
      reloadFn()
      fn && fn()
    }).catch(err=>{
      setAddOrEditFooterLoading(false)
    })
  };
  // 表格加载
  const fetchList = (values: any) => {
    return new Promise(async (resolve, reject) => {
      try {
        let data = {
          sourceBillType: rest.sourceBillType,
          sourceId: rest.id 
        }
        findVerifyApplyResponseList(data).then((res)=>{
          console.log(res)
          resolve(res)
        })
      } catch (e) {
        reject({ success: false });
      }
    });
  };
  // 刷新
  const reloadFn = () => {
    const {
      current: { reload },
    } = listRef;
    reload();
  };
  const extension = {
    request: {
      fetchList,
      //getStatusOptions
    },
    events: {},
    customRender: {},
  };
  return (<Spin spinning={addOrEditFooterLoading}>
    <div style={{ paddingBottom: 15 }}>
      <SLowcodeList
        searchMode="group"
        config={{
          rowSelection: false,
          pagination: false,
          columns: [
            {
              title: '核销单号',
              dataIndex: 'billNo',
              width: 160,
            },
            {
              title: '核销时间',
              dataIndex: 'verifiedDate',
              itemType: 'dateTime',
              width: 120,
            },
            {
              title: '核销金额',
              dataIndex: 'verifiedAmount',
              width: 100,
              render: (text: any, record: any) => {
                return (
                  <div>
                    {
                      record?.dtlResponseList && record?.dtlResponseList.map((item, index) => {
                        return (
                          <div key={index}>
                            <div>{item.verifiedAmount}</div>
                            {/* 仅在不是最后一个元素时显示 Divider */}
                            {index < record.dtlResponseList.length - 1 && <Divider style={{margin: '10px 0'}} />}
                          </div>
                        )
                      })
                    }
                  </div>
                )
              }
            },
            {
              title: '源单类型',
              dataIndex: 'sourceBillTypeName',
              width: 160,
              render: (text: any, record: any) => {
                return (
                  <div>
                    {
                      record?.dtlResponseList && record?.dtlResponseList.map((item, index) => {
                        return (
                          <div key={index}>
                            <div>{item.sourceBillTypeName}</div>
                            {/* 仅在不是最后一个元素时显示 Divider */}
                            {index < record.dtlResponseList.length - 1 && <Divider style={{margin: '10px 0'}} />}
                          </div>
                        )
                      })
                    }
                  </div>
                )
              }
            },
            {
              title: '单号',
              dataIndex: 'sourceCode',
              width: 180,
              render: (text: any, record: any) => {
                return (
                  <div>
                    {
                      record?.dtlResponseList && record?.dtlResponseList.map((item, index) => {
                        return (
                          <div key={index}>
                            <div>{item.sourceCode}</div>
                            {/* 仅在不是最后一个元素时显示 Divider */}
                            {index < record.dtlResponseList.length - 1 && <Divider style={{margin: '10px 0'}} />}
                          </div>
                        )
                      })
                    }
                  </div>
                )
              }
            },
            {
              title: '操作',
              dataIndex: 'actions',
              width: 100,
              render: (text: any, record: any) => {
                // 直接根据权限值控制显示，直接放组件上有问题 auth="VerificationDetailsCancelReceivable"
                if (!auth['VerificationDetailsCancelReceivable']) {
                  return null;
                }
                return (
                  <STableActions>
                    <SActionBtn  onClick={() => cancel(record)}>
                      取消核销
                    </SActionBtn>
                  </STableActions>
                );
              },
              fixed: 'right',
            },
          ],
          search: [],
          footer: [],
          
        }}
        ref={listRef}
        {...extension}
      />
    </div>
    </Spin>
  );
};
